import { h } from "@stencil/core";
import { renderInlineError } from "../../../utils";
import { LinkType } from "../../shared/models/atoms/bbg-link/link-type.enum";
export class BbgLink {
  constructor() {
    /** The link's type. Possible values: 'primary', 'simple'. */
    this.type = LinkType.simple;
    /** Marks the link as disabled and not clickable. */
    this.disabled = false;
    /** The HTML href attribute. Default is '#'. */
    this.href = "#";
    /** The link's icon. Default is none */
    this.icon = undefined;
    /** the icon's position. Possible values: 'left', 'right'. */
    this.iconPosition = "left";
    /** The HTML target attribute. Default is '_self'. */
    this.target = "_self";
  }
  render() {
    if (LinkType[this.type] === undefined) {
      return renderInlineError(`Unknown link type '${this.type}'`);
    }
    const linkCssClasses = {
      "a-link": true,
      "a-link--simple": this.type === LinkType.simple,
      "a-link--primary": this.type === LinkType.primary,
      "-disabled": this.disabled,
      "-icon-left": this.type === LinkType.simple && this.icon && this.iconPosition === "left",
      "-icon-right": this.type === LinkType.simple && this.icon && this.iconPosition === "right",
    };
    return (h("div", { class: linkCssClasses }, h("a", { href: this.href, target: this.target, "aria-label": this.ariaLabel }, this.icon && this.iconPosition === "left" && h("bbg-icon", { name: this.icon }), h("slot", null), this.icon && this.iconPosition === "right" && h("bbg-icon", { name: this.icon }))));
  }
  static get is() { return "bbg-link"; }
  static get originalStyleUrls() {
    return {
      "$": ["bbg-link.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bbg-link.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The link's type. Possible values: 'primary', 'simple'."
        },
        "attribute": "type",
        "reflect": false,
        "defaultValue": "LinkType.simple"
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Marks the link as disabled and not clickable."
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "href": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The HTML href attribute. Default is '#'."
        },
        "attribute": "href",
        "reflect": false,
        "defaultValue": "\"#\""
      },
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The link's icon. Default is none"
        },
        "attribute": "icon",
        "reflect": false,
        "defaultValue": "undefined"
      },
      "iconPosition": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "the icon's position. Possible values: 'left', 'right'."
        },
        "attribute": "icon-position",
        "reflect": false,
        "defaultValue": "\"left\""
      },
      "target": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The HTML target attribute. Default is '_self'."
        },
        "attribute": "target",
        "reflect": false,
        "defaultValue": "\"_self\""
      },
      "ariaLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The HTML aria-label attribute. Default is empty."
        },
        "attribute": "aria-label",
        "reflect": false
      }
    };
  }
}
